import {FC, useEffect} from "react";
import { useT } from '../../../../helpers/i18n';
import Checkers from "../../../../helpers/class/Checkers";
import {raw} from "express";

interface AttributesListProps {
    data: any
}
const AttributesList: FC<AttributesListProps> = ({data} ) => {
    const t = useT();

    // useEffect(() => {
    //     console.log("forDebug", "spaceLevelLabel", data.space_level_label)
    // }, [data])

    return (
        <>
            {
                <>
                    <ul className={'m-t-20 m-b-40 row'}>
                        {
                            data.space_position_label != undefined && data.space_position_label != null && data.space_position_label.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.position')}&nbsp;<strong>{data.space_position_label}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.space_level_label != undefined && data.space_level_label != null && data.space_level_label.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.level')}&nbsp;<strong>{data.space_level_label}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.space_layout_label != undefined && data.space_layout_label != null && data.space_layout_label.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.spaces')}&nbsp;<strong>{data.space_layout_label}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.space_orientation_label != undefined && data.space_orientation_label != null && data.space_orientation_label.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.orientation')}&nbsp;<strong>{data.space_orientation_label}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.pool_type_label != undefined && data.pool_type_label != null && data.pool_type_label.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.type')}&nbsp;<strong>{data.pool_type_label}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.pool_area_sqm != undefined && data.pool_area_sqm != null && data.pool_area_sqm.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.area')}&nbsp;<strong>{data.pool_area_sqm}&nbsp;{t('unit.sqm')}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.bedroom_area_sqm != undefined && data.bedroom_area_sqm != null && data.bedroom_area_sqm.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.area')}&nbsp;<strong>{data.bedroom_area_sqm}&nbsp;{t('unit.sqm')}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.min_depth != undefined && data.min_depth != null && data.min_depth.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.minDepth')}&nbsp;<strong>{data.min_depth}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.max_depth != undefined && data.max_depth != null && data.max_depth.length > 0 ?
                                <>
                                    <li className={'col-md-12 fs-16'}>
                                        {t('space.maxDepth')}&nbsp;<strong>{data.max_depth}</strong>
                                    </li>
                                </>
                                :
                                <></>
                        }
                    </ul>
                </>
            }
        </>
    )
}

export default AttributesList